module.exports = __webpack_public_path__ + "img/body-tile-one-lg.289a517a.png";